/* filter.ts */

/* Interfaces */
import { FilterType } from "src/shared/interfaces/insights-filter/InsightsFilter";

/**
 * Define available filters based on the url.
 */
export const availableInsightsFilter: Record<
  string,
  FilterType[]
> = {
  "/insights/descriptive-statistics": [
    FilterType.MAIN_CONDITION,
    FilterType.FEATURES,
    FilterType.COHORTS,
    FilterType.TIME_PERIOD,
    FilterType.CARE_SITES,
  ],
  "/insights/survival-analysis": [
    FilterType.MAIN_CONDITION,
    FilterType.COHORTS,
    FilterType.TIME_PERIOD,
    FilterType.CARE_SITES,
  ],
  "/insights/treatment-patterns": [
    FilterType.MAIN_CONDITION,
    FilterType.CUSTOM_FEATURES,
    FilterType.COHORTS,
    FilterType.TIME_PERIOD,
    FilterType.CARE_SITES,
  ],
};
